import { Component, OnInit } from '@angular/core';
import {ListeContact} from '../../../../../model/liste/ListeContact';
import {Contact} from '../../../../../model/contact/Contact';
import {TypeListe} from '../../../../../model/liste/TypeListe';
import {AuthUser} from '../../../../../model/user/authUser';
import {AuthShareService} from '../../../../../service/partage/AuthShareService';
import {DialogueShareService} from '../../../../../service/partage/utilitaire/DialogueShareService';
import {NgxSpinnerService} from 'ngx-spinner';
import {ListeContactService} from '../../../../../service/interne/contact/ListeContactService';
import {ContactService} from '../../../../../service/interne/contact/ContactService';
import {AuthUserService} from '../../../../../service/interne/user/AuthUserService';
import {ActivatedRoute} from '@angular/router';
import {ListeContactContact} from '../../../../../model/liste/ListeContactContact';
import {GestionnaireListe} from '../../../../../model/liste/GestionnaireListe';

@Component({
  selector: 'app-escal-liste-contact-modifier',
  templateUrl: './escal-liste-contact-modifier.component.html',
  styleUrls: ['./escal-liste-contact-modifier.component.scss'],
  providers: [ ContactService, ListeContactService, AuthUserService ]
})
export class EscalListeContactModifierComponent implements OnInit {

  private sub: any;
  listeContact: ListeContact;
  contacts: Array<Contact>;
  types: Array<TypeListe>;
  typeId: number;
  contactsIds: Array<any> = [];
  contactsChoix: Array<Contact>;
  idContactsSelectionnes: Array<any> = [];
  idContactsASauvegarder: Array<any> = [];
  contactSelect: Contact;
  listeId: number;
  cree: boolean;
  redirection: boolean;
  champRechercheContact = '';
  champRechercheContactCategorie = '';
  champRechercheContactSousCategorie = '';
  gestionnaireIds: Array<any> = [];
  users: Array<AuthUser> = [];
  assosContactsListe: Array<ListeContactContact>;
  assosGestionnairesListe: Array<GestionnaireListe>;
  constructor(private authShareService: AuthShareService, private dialogueShareService: DialogueShareService,
              private spinner: NgxSpinnerService, private listeContactService: ListeContactService,
              private contactService: ContactService, private authUserService: AuthUserService, private route: ActivatedRoute) { }

  ngOnInit() {
    this.cree = false;
    this.redirection = false;
    this.listeId = 0;
    this.typeId = 0;
    this.contacts = [];
    this.contactsChoix = [];
    this.sub = this.route.params.subscribe(params => {
      this.listeContactService.getListeContactDetails(params.id)
        .then((listeContact) => {
          this.listeContact = listeContact as ListeContact;
          if (this.listeContact.type != null) {
            this.typeId = this.listeContact.type.id;
          }
          this.gestionnaireIds = [];
          this.listeContact.gestionnaireListes.forEach(gestionnaire => {
            this.gestionnaireIds.push(gestionnaire.gestionnaire.id.toString());
          });
          this.listeContactService.getListeAllContacts(this.listeContact.id).then((contactsListe) => {
            this.contacts = contactsListe['hydra:member'] as Array<Contact>;
          });
        });
      this.listeContactService.getAllAssosListeContact(params.id).then((assosContactsListe) => {
        this.assosContactsListe = assosContactsListe['hydra:member'] as Array<ListeContactContact>;
      });
      this.listeContactService.getAllAssosGestionnaireListeContact(params.id).then((assosGestionnairesListe) => {
        this.assosGestionnairesListe = assosGestionnairesListe['hydra:member'] as Array<GestionnaireListe>;
      });
    });
    this.listeContactService.getTypesListe().then((types) => {
      this.types = types['hydra:member'] as Array<TypeListe>;
    });
    this.authUserService.getUsersList(1).then((usersRetour) => {
      this.users = usersRetour['hydra:member'] as Array<AuthUser>;
    });
  }
  rechercheContact() {
    this.contactService.getContactRechercheByNomPrenom(this.champRechercheContact)
      .then((data) => {
        this.contactsChoix = data['hydra:member'] as Array<Contact>;
      });
  }

  rechercheContactCategorie() {
    this.contactService.getContactRechercheByCategorie(this.champRechercheContactCategorie)
      .then((data) => {
        this.contactsChoix = data['hydra:member'] as Array<Contact>;
      });
  }

  rechercheContactSousCategorie() {
    this.contactService.getContactRechercheBySousCategorie(this.champRechercheContactSousCategorie)
      .then((data) => {
        this.contactsChoix = data['hydra:member'] as Array<Contact>;
      });
  }

  setSelected(selectElement, action, nature) {
    const groupe: Array<any> = [];
    let optionSelected;
    for (let i = 0; i < selectElement.options.length; i++) {
      if (selectElement.options[i].selected) {
        optionSelected = selectElement.options[i].value;
        // Le format de value est de [0: '1']
        if (optionSelected.indexOf('\'') !== -1) {
          // extraire le vrai id sauvegarder
          optionSelected = optionSelected.indexOf('\'');
          optionSelected = selectElement.options[i].value.slice(optionSelected);
          optionSelected = this.extraitNombre(optionSelected);
          optionSelected = optionSelected.toString();
        }
        groupe.push(optionSelected);
      }
    }
    if (action === 'add') {
      switch (nature) {
        case 'liste':
          this.idContactsSelectionnes = groupe;
          break;
      }
    } else if (action === 'delete') {
      switch (nature) {
        case 'liste':
          this.idContactsASauvegarder = groupe;
          break;
      }
    }
  }

  extraitNombre(str) {
    return Number(str.replace(/\D/g, ''));
  }

  changeContact(action) {
    const that = this;
    let nouvelleListeContacts;
    let listeContacts;
    let contactPresent;
    if (action === 'add') {
      listeContacts = this.idContactsSelectionnes;
    } else {
      listeContacts = this.idContactsASauvegarder;
    }
    listeContacts.forEach((idContactsSelectionnes) => {
      that.contactService.getContactDetail(idContactsSelectionnes).then(retour => {
        that.contactSelect = retour as Contact;
        if (action === 'add') {
          // retirer le(s) contact(s) sélectionné(s) dans la liste de base
          nouvelleListeContacts = this.contactsChoix.filter((contact) => contact.id !== that.contactSelect.id);
          this.contactsChoix = nouvelleListeContacts;
          // évite les doublons
          contactPresent = this.contacts.find((contact) => contact.id === that.contactSelect.id);
          if (contactPresent === undefined) {
            this.contacts.push(that.contactSelect);
          }
        } else if (action === 'delete') {
          // retirer le(s) contact(s) sélectionné(s) dans la liste à sauvegarder
          nouvelleListeContacts = this.contacts.filter((contact) => contact.id !== that.contactSelect.id);
          this.contacts = nouvelleListeContacts;
          // évite les doublons
          contactPresent = this.contactsChoix.find((contact) => contact.id === that.contactSelect.id);
          if (contactPresent === undefined) {
            this.contactsChoix.push(that.contactSelect);
          }
        }
      });
    });
  }

  modifierListe() {
    // si informations obligatoires non renseignées
    if (this.listeContact.nom != '') {
      // empeche la creation de multiple liste
      this.cree = true;
      this.spinner.show();
      // modifier liste
      this.listeContactService.modifierListeContact(this.listeContact, this.typeId).then(async listeContact => {
        this.listeId = listeContact.id;
        if (this.contacts.length > 0) {
          for (const assosContactListe of this.assosContactsListe) {
            // Sinon mettre à jour les assos via la selection dans le formulaire escalnet
            await this.listeContactService.supprimerAssoListeContact(assosContactListe.id).then(() => {
            });
          }
          for (const contact of this.contacts) {
            await this.listeContactService.addContactListe(this.listeId, contact.id);
          }
        } else {
          for (const assosContactListe of this.assosContactsListe) {
            await this.listeContactService.supprimerAssoListeContact(assosContactListe.id).then(() => {
            });
          }
        }
        if (this.gestionnaireIds.length > 0) {
          for (const assosGestionnaireListe of this.assosGestionnairesListe) {
            await this.listeContactService.supprimerGestionnaireListeContact(assosGestionnaireListe.id);
          }
          for (const gestionnaire of this.gestionnaireIds) {
            await this.listeContactService.addGestionnaireListe(this.listeId, gestionnaire);
          }
        }
        // enregistrer liste contact dans la base d'intranet
        await this.listeContactService.importerListeContactIntranet(listeContact.id, this.listeContact.ancienId)
          .then(async (ancienIdListe) => {
            this.spinner.hide();
            this.dialogueShareService.addDialogue('La liste a bien été modifiée');
            this.redirection = true;
          });
      });
    } else {
      this.dialogueShareService.addDialogue('Le nom est obligatoire');
    }
  }

}
